import { render } from "./NotFound.vue?vue&type=template&id=29c81b50"
const script = {}
script.render = render

export default script